import React, { useEffect, useState, useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "components/common";
import { OKTA_TYPE_KEY } from "authentication/components/oidc/constants";
import { OidcSessionActions } from "./OidcSessionStore";
import OidcGenericLoginLink from "./OidcGenericLoginLink";
import OktaLoginForm from "../okta/OktaLoginForm";
const OidcCallback = ({ configuration, nonce, onErrorChange, params, regenerateNonce }) => {
  const { t } = useTranslation("enterprise_authentication");
  const [isLoading, setIsLoading] = useState(false);
  const [loginFailed, setLoginFailed] = useState(false);
  const isRegenerated = useRef(false);
  const generateNonce = useCallback(() => {
    if (!isRegenerated.current) {
      regenerateNonce();
      isRegenerated.current = true;
    }
  }, [regenerateNonce]);
  useEffect(() => {
    const handleLoginFailure = () => {
      setLoginFailed(true);
      generateNonce();
    };
    if (loginFailed) {
      return () => {
      };
    }
    if (params.error_description) {
      onErrorChange(params.error_description);
      handleLoginFailure();
      return () => {
      };
    }
    if (nonce.state !== params.state) {
      onErrorChange(t("oidc.oidc_callback.csrf_error"));
      handleLoginFailure();
      return () => {
      };
    }
    setIsLoading(true);
    const promise = OidcSessionActions.login(params.code);
    promise.catch((error) => {
      if (error.status === 401) {
        onErrorChange(t("oidc.oidc_callback.login_failed"));
      } else {
        onErrorChange(t("oidc.oidc_callback.unknown_error"));
      }
      handleLoginFailure();
      setIsLoading(false);
      return error;
    });
    return () => {
      var _a;
      if (promise) {
        (_a = promise.cancel) == null ? void 0 : _a.call(promise);
      }
    };
  }, [generateNonce, loginFailed, nonce.state, onErrorChange, params, t]);
  if (isLoading) {
    return /* @__PURE__ */ React.createElement("p", { className: "loading-text" }, /* @__PURE__ */ React.createElement(Spinner, { text: t("oidc.oidc_callback.loading"), delay: 0 }));
  }
  return configuration.oauth_type === OKTA_TYPE_KEY ? /* @__PURE__ */ React.createElement(OktaLoginForm, { configuration, nonce }) : /* @__PURE__ */ React.createElement(OidcGenericLoginLink, { configuration, nonce });
};
export default OidcCallback;
